export default __webpack_public_path__ + "static/nodejs-8e341cc00e4ec40c6a2708bfec56b60f.png";